export default "__VITE_ASSET__BrJwrsMz__"